var map = {
	"./ESG.svg": 7574,
	"./Excel.svg": 8803,
	"./answer-A.svg": 5197,
	"./contact_us.svg": 1903,
	"./describe.svg": 4514,
	"./download.svg": 7084,
	"./earth.svg": 2238,
	"./email-shadow.svg": 2870,
	"./email.svg": 4413,
	"./funds-help.svg": 8533,
	"./home-link-arrow.svg": 9994,
	"./home-people.svg": 1705,
	"./home-tree.svg": 3139,
	"./home-water.svg": 7439,
	"./info-circle.svg": 7354,
	"./link-arrow.svg": 9182,
	"./logo.svg": 6316,
	"./pdf.svg": 82,
	"./public-account.svg": 5353,
	"./question-Q.svg": 8492,
	"./quotes-left.svg": 7329,
	"./quotes-right.svg": 3473,
	"./wechat-shadow.svg": 2114,
	"./wechat.svg": 675
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2007;